import type { UserDisplayPreferencesPayload } from "./types";
import type { NetworkPayload } from "../../../composites";

const URL = "me/display_preferences";

export const API = {
  getUserDisplayPreferences:
    (): NetworkPayload<UserDisplayPreferencesPayload> => {
      return {
        url: URL,
        options: {
          method: "GET",
          isJsonResponse: true,
        },
      };
    },
  createUserDisplayPreferences: (
    payload: UserDisplayPreferencesPayload,
  ): NetworkPayload<UserDisplayPreferencesPayload> => {
    return {
      url: URL,
      options: {
        method: "POST",
        payload,
        isJsonResponse: true,
      },
    };
  },
  editUserDisplayPreferences: (
    payload: UserDisplayPreferencesPayload,
  ): NetworkPayload<UserDisplayPreferencesPayload> => {
    return {
      url: URL,
      options: {
        payload,
        method: "PATCH",
        isJsonResponse: true,
      },
    };
  },
  deleteUserDisplayPreferences: (): NetworkPayload => {
    return {
      url: URL,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
};
